export interface TableEventHandlers {
  handleSortOptions: (sortCamp: string, orderFlow: string) => void;
  handleFilter: (filters: any) => void;
}

export interface TableEmitter {
  (e: 'update:sort', sortCamp: string, orderFlow: string): void;
  (e: 'update:filter', filters: any): void;
}

export function useTableEvents(emit: TableEmitter): TableEventHandlers {
  const handleSortOptions = (sortCamp: string, orderFlow: string) => {
    emit('update:sort', sortCamp, orderFlow);
  };

  const handleFilter = (filters: any) => {
    emit('update:filter', filters);
  };

  return {
    handleSortOptions,
    handleFilter,
  };
}